import { Component, h } from 'preact'
import Header from '../header'
import { EmailInfo } from './overview'
import InputGroup from '../ui-components/InputGroup'
import Axios from 'axios'
import AlertComponent from '../ui-components/AlertComponent'
import { RawEmailEditor } from '../raw-email-editor/RawEmailEditor'

interface State {
  emailSubject: string,
  emailBody: string,
  message: string,
  messageType: null | string
}

class EmailEdit extends Component<EmailInfo, State> {
  constructor (props: EmailInfo) {
    super(props)
    this.state = {
      emailSubject: props.subjectTranslation,
      emailBody: props.bodyTranslation,
      message: '',
      messageType: null
    }
    this.onSave = this.onSave.bind(this)
    this.onEmailBodyChange = this.onEmailBodyChange.bind(this)
  }

  async onSave () {
    this.setState({ messageType: null })
    let subjectResponse
    let bodyResponse

    if (this.state.emailSubject !== this.props.subjectTranslation) {
      subjectResponse = Axios.post('/email/system-emails/save', {
        category: this.props.subjectModule,
        message: this.props.subjectKey,
        translation: this.state.emailSubject
      })
    }
    if (this.state.emailBody !== this.props.bodyTranslation) {
      bodyResponse = Axios.post('/email/system-emails/save', {
        category: this.props.bodyModule,
        message: this.props.bodyKey,
        translation: this.state.emailBody
      })
    }

    try {
      await Promise.all([subjectResponse, bodyResponse])
      this.setState({ messageType: 'success', message: 'Email is saved successfully!' }, () => {
        window.setTimeout(() => window.location.assign('/email/system-emails'), 3000)
      })
    } catch (err) {
      this.setState({ messageType: 'error', message: 'Something went wrong' })
    }
  }

  onEmailBodyChange (html: string) {
    this.setState({ emailBody: html })
  }

  render ({ type, title, subjectModule, subjectKey, bodyModule, bodyKey, description }: EmailInfo,
    { emailSubject, emailBody, messageType, message }: State) {
    return (
      <div className='email-template-edit-page'>
        <Header
          title={`Edit '${title}' email`}
          hasBreadcrumb
          breadcrumbText='Back to System Emails'
          breadcrumbLink='/email/system-emails'
          saveCallback={this.onSave}
        />
        {
          messageType ? <AlertComponent messageType={messageType} message={message} sticky renderHTML isVisibleFor={3000} /> : null
        }
        <div>
          <div className='email-template-description'> { description } </div>
          <InputGroup
            title='Subject'
            type='text'
            onChange={(e: {target: HTMLInputElement}) => { this.setState({ emailSubject: e.target.value }) }}
            value={emailSubject}
          />
          <RawEmailEditor
            content={emailBody}
            onContentChange={this.onEmailBodyChange}
          />
        </div>
      </div>
    )
  }
}

export default EmailEdit
